<template>
  <div class="container">
    <aside class="aside" :style="{ width: asideWidth }">
      <div class="logo-wrapper">
        <img src="~@/assets/images/logo2.png" :style="{ width: logoWidth }" class="logo" alt="">
        <span v-if="!collapse" class="title">GAME FOR YOU</span>
      </div>
      <nav-menu class="menu-wrapper" :collapseFlag="collapse" @noCollapse="noCollapse"></nav-menu>
    </aside>
    <div class="container-main" :style="{ width: mainWidth }">
      <div class="header">
        <div class="collapse" @click="collapse=!collapse"></div>
      </div>
      <div class="panel">
        <router-view class="content" />
      </div>
    </div>
  </div>
</template>

<script>
import NavMenu from '@/components/menu/index.vue';

export default {
  components: { NavMenu },
  created() {
    this.userName = sessionStorage.getItem('user_name');
  },
  computed: {
    asideWidth() {
      return `${this.collapse ? 55 : 252}px`;
    },
    logoWidth() {
      return `${this.collapse ? 75 : 25}%`;
    },
    mainWidth() {
      return `calc(100% - ${this.asideWidth})`;
    },
  },
  data() {
    return {
      collapse: true,
      userName: '',
    };
  },
  methods: {
    logout() {
      sessionStorage.clear();
      this.$router.push('/login');
    },
    noCollapse() {
      if (this.collapse) {
        this.collapse = false;
      }
    },
  },
};
</script>


<style lang="less" scoped>
.container {
  display: flex;
  height: 100%;
}
.aside {
  display: flex;
  flex-direction: column;

  .logo-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 56px;
    background-color: #404571;
    .title {
      padding: 10px;
      font-size: 20px;
      color: #fff;
    }
  }
  .menu-wrapper {
    flex: 1;
    width: 100%;
  }
}
.container-main {
  overflow-y: auto;
  background-color: #f3f7fd;

  .menu-title {
    margin: 0;
    padding-left: 24px;
    height: 68px;
    line-height: 68px;
    font-size: 20px;
    color: #333333;
    background-color: #ffffff;
  }

  .panel {
    flex: 1;
    padding: 24px;

    .content {
      padding: 10px 10px 0px 10px;
      background-color: #ffffff;
      border-radius: 4px;
    }
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding-right: 24px;
  background-color: #ffffff;
  border-bottom: 1px solid #ebebeb;
}
.collapse {
  width: 72px;
  height: 56px;
  cursor: pointer;
  background-image: url(~@/assets/images/icon/collapse.png);
  &:hover {
    background-image: url(~@/assets/images/icon/collapse-hover.png);
  }
}
.greeting {
  cursor: pointer;

  i {
    margin-left: 12px;
  }

  &-dropdown {
    min-width: 100px;
  }
}

@media (max-width: 768px) {
}
</style>
<style>
.aside .menu-wrapper[data-v-5954443c] li {
  padding-left: 13px !important;
}
</style>
